import React, { useEffect, useState } from "react";
import Modal from "react-modal"; // Assuming you have a modal library like react-modal
import { AiOutlineArrowLeft } from "react-icons/ai";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import { FaEye } from "react-icons/fa";
import { MdEdit } from "react-icons/md";

const ProfilePayment = ({ selectedProfile, key }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [paymentInits, setPaymentInits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [refresh, setRefresh] = useState(new Date());

  const formattedAmount = (value) => {
    // Check if value is defined and not null
    if (value !== undefined && value !== null) {
      // Remove commas from the input value
      const cleanValue = value.replace(/,/g, "");
      // Parse the cleaned value as a float
      const parsedValue = parseFloat(cleanValue);
      // If parsing is successful and the value is not NaN, return formatted value
      if (!isNaN(parsedValue)) {
        return parsedValue.toLocaleString();
      }
    }
    // Otherwise, return the original input value
    return value;
  };

  const setInitialize = () => {
    setFormData({});
    setIsModalOpen(true);
  };

  const recordPayment = () => {
    setPaymentFormData({
      ...paymentFormData,
      year: new Date().getFullYear(),
    });
    setIsModal2Open(true);
  };

  const [formData, setFormData] = useState({
    employeeId: selectedProfile.emp
      ? selectedProfile.emp.id
      : selectedProfile.id,
    id: "",
    year: "",
    amount: "",
  });

  const [paymentFormData, setPaymentFormData] = useState({
    employeeId: selectedProfile.emp && selectedProfile.emp.id ? selectedProfile.emp.id : selectedProfile.id,
    id: "",
    year: "",
    amount: "",
    paymentMode: "",
    dateOfPayment: null,
    referenceNumber: "",
  });

  useEffect(() => {
    const employeeId = selectedProfile.emp ? selectedProfile.emp.id : selectedProfile.id;
    setLoading(true);
    axios
      .get(`${apiUrl}/payment/getInitialPayment/${employeeId}`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        const inits = res.data;
        if (inits.length > 0) {
          const promises = inits.map((init) =>
            axios.get(`${apiUrl}/payment/getPaymentsWithBalance/${employeeId}/${init.year}`, {
              headers: {
                loginToken: localStorage.getItem("loginToken"),
              },
            })
          );
          Promise.all(promises)
            .then((responses) => {
              const allPayments = [];
              let totalPaid = 0;
              let totalBalance = 0;
              responses.forEach((res) => {
                allPayments.push(...res.data.payments);
                totalPaid += parseFloat(res.data.totalPayments || 0);
                totalBalance += parseFloat(res.data.balance || 0);
              });
              setPayments({
                payments: allPayments,
                totalPayments: totalPaid,
                balance: totalBalance,
              });
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            });
        } else {
          setPayments({ payments: [], totalPayments: 0, balance: 0 });
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [refresh, selectedProfile]);

  useEffect(() => {
    // Clear all payment-related data when the component is loaded
    setPayments([]);
    setPaymentInits([]);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePaymentDateChange = (date) => {
    setPaymentFormData((prevData) => ({
      ...prevData,
      dateOfPayment: date,
    }));
  };

  const deletePayment = (id) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record?",
      icon: "warning", //The right way
      dangerMode: "red",
      closeModal: false,
      buttons: ["No", "Yes"], //The right way to do it in Swal1
    }).then((isConfirm) => {
      if (isConfirm) {
        axios
          .delete(`${apiUrl}/payment/deletePayment/${id}`, {
            headers: {
              loginToken: localStorage.getItem("loginToken"),
            },
          })
          .then((res) => {
            setRefresh(new Date());
            swal({
              icon: "success",
              title: "Success",
              text: "Record deleted",
            });
          })
          .catch((err) => {
            if (err.response) {
              swal({
                icon: "error",
                title: "Error",
                text: err.response?.data?.error,
              });
            } else {
              swal({
                icon: "error",
                title: "Error",
                text: err.message,
              });
              console.log(err);
            }
          });
      }
    });
  };

  const deleteInitialPayment = (id) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record?",
      icon: "warning", //The right way
      dangerMode: "red",
      closeModal: false,
      buttons: ["No", "Yes"], //The right way to do it in Swal1
    }).then((isConfirm) => {
      if (isConfirm) {
        axios
          .delete(`${apiUrl}/payment/deleteInitialPayment/${id}`, {
            headers: {
              loginToken: localStorage.getItem("loginToken"),
            },
          })
          .then((res) => {
            setRefresh(new Date());
            swal({
              icon: "success",
              title: "Success",
              text: "Record deleted",
            });
          })
          .catch((err) => {
            if (err.response) {
              swal({
                icon: "error",
                title: "Error",
                text: err.response?.data?.error,
              });
            } else {
              swal({
                icon: "error",
                title: "Error",
                text: err.message,
              });
              console.log(err);
            }
          });
      }
    });
  };

  const editInit = (data) => {
    //alert(JSON.stringify(data))
    setFormData(data);

    setIsModalOpen(true);
  };

  const editPayments = (data) => {
    //alert(JSON.stringify(data))

    setPaymentFormData({
      ...data,
      dateOfPayment: data.dateOfPayment ? new Date(data.dateOfPayment) : null,
    });

    setIsModal2Open(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof formData.id === "number") {
      axios
        .put(`${apiUrl}/payment/editInitialPayment`, formData, {
          headers: {
            loginToken: localStorage.getItem("loginToken"),
          },
        })
        .then((res) => {
          if (res.data.status[0]) {
            swal({
              title: "Updated!",
              icon: "success",
              text: "Initial Payment has been updated",
            });

            setRefresh(new Date());
          } else {
            swal({
              title: "Oops!",
              icon: "error",
              text: "Initial Payment has not been updated",
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            swal({
              icon: "error",
              title: "Error",
              text: err.response?.data?.error,
            });
          } else {
            swal({
              icon: "error",
              title: "Error",
              text: err.message,
            });
            console.log(err);
          }
        });
    } else {
      axios
        .post(
          `${apiUrl}/payment/addInitialPayment`,
          {
            employeeId: selectedProfile.emp
              ? selectedProfile.emp.id
              : selectedProfile.id,
            year: formData.year,
            amount: formData.amount,
          },
          {
            headers: {
              loginToken: localStorage.getItem("loginToken"),
            },
          }
        )
        .then((res) => {
          setPaymentInits((prev) => [...prev, res.data]);

          swal({
            title: "Success",
            text: "Record has been added successfully",
            icon: "success",
          });
        })
        .catch((err) => {
          if (err.response) {
            swal({
              icon: "error",
              title: "Error",
              text: err.response?.data?.error,
            });
          } else {
            swal({
              icon: "error",
              title: "Error",
              text: err.message,
            });
            console.log(err);
          }
        });
    }

    setIsModalOpen(false);
  };

  const handlePaymentSubmit = (e) => {
    e.preventDefault();

    if (typeof paymentFormData.id === "number") {
      axios
        .put(
          `${apiUrl}/payment/editPayment`,
          {
            updated: paymentFormData,
          },
          {
            headers: {
              loginToken: localStorage.getItem("loginToken"),
            },
          }
        )
        .then((res) => {
          setRefresh(new Date());

          if (res.data.status[0]) {
            swal({
              title: "Updated!",
              text: "Record has been edited",
              icon: "success",
            });
          }

          setIsModal2Open(false);
        })
        .catch((err) => {
          if (err.response) {
            swal({
              icon: "error",
              title: "Error",
              text: err.response?.data?.error,
            });
          } else {
            swal({
              icon: "error",
              title: "Error",
              text: err.message,
            });
            console.log(err);
          }
        });
    } else {
      axios
        .post(
          `${apiUrl}/payment/makePayment`,
          paymentFormData,
          {
            headers: {
              loginToken: localStorage.getItem("loginToken"),
            },
          }
        )
        .then((res) => {
          setRefresh(new Date());

          swal({
            title: "Success",
            text: "Record has been added successfully",
            icon: "success",
          });

          setIsModal2Open(false);
        })
        .catch((err) => {
          if (err.response) {
            swal({
              icon: "error",
              title: "Error",
              text: err.response?.data?.error,
            });
          } else {
            swal({
              icon: "error",
              title: "Error",
              text: err.message,
            });
            console.log(err);
          }
        });
    }
    //alert(JSON.stringify(updated))

    setIsModalOpen(false);
  };

  const handleDetails = () => {
    setPayments([]);
    setPaymentInits([]);
    setIsModalOpen(false);
    setIsModal2Open(false);
    // Remove the Payment History section
    const paymentHistorySection = document.querySelector(".flex.flex-col.items-center.justify-center.w-full.mt-8");
    if (paymentHistorySection) {
      paymentHistorySection.remove();
    }
  };

  return (
    <div className="w-full h-full pb-10 flex flex-col flex-1">
      <div className="flex flex-wrap gap-3 items-center justify-between">
        <div></div>

        <h2 className="text-[13pt] font-semibold">
          Manage payments for{" "}
          {selectedProfile.emp
            ? selectedProfile.emp.firstName
            : selectedProfile.firstName}
        </h2>

        <div></div>
      </div>

      {/* Form Modal */}
      <Modal
        isOpen={isModalOpen}
        contentLabel="Form Modal"
        ariaHideApp={false} // Disable accessibility warning
      >
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto"
        >
          <h2 className="text-xl font-bold text-center mb-4">
            Initialize a Payment
          </h2>
          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Year
            </label>
            <input
              type="text"
              name="year"
              value={formData.year}
              onChange={handleInputChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
              placeholder="Enter year"
              required
            />
          </div>
          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Amount
            </label>
            <input
              type="text"
              name="amount"
              value={formattedAmount(formData.amount)}
              onChange={handleInputChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
              placeholder="Enter amount"
              required
            />
          </div>
          <div className="flex justify-between mt-6">
            <button
              type="submit"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-5 rounded-lg shadow-md transition duration-150 ease-in-out"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={() => setIsModalOpen(false)}
              className="inline-block bg-gray-300 hover:bg-gray-400 text-gray-700 font-semibold py-2 px-5 rounded-lg shadow-md transition duration-150 ease-in-out"
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>

      {/* payment Form Modal */}
      <Modal
        isOpen={isModal2Open}
        contentLabel="Form Modal"
        ariaHideApp={false} // Disable accessibility warning
      >
        <form
          onSubmit={handlePaymentSubmit}
          className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto"
        >
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
            Record Payment
          </h2>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Amount
            </label>
            <input
              type="text"
              name="amount"
              value={formattedAmount(paymentFormData.amount)}
              onChange={handlePaymentInputChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
              placeholder="Enter amount"
              required
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date of Payment
            </label>
            <DatePicker
              selected={paymentFormData.dateOfPayment}
              onChange={(date) => handlePaymentDateChange(date)}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
              placeholderText="Enter Date"
              required
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mode of Payment
            </label>
            <select
              name="paymentMode"
              value={paymentFormData.paymentMode}
              onChange={handlePaymentInputChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
              required
            >
              <option value="">Select ...</option>
              <option value="Cash">Cash</option>
              <option value="Bank">Bank</option>
              <option value="Mobile Wallet">Mobile Wallet</option>
            </select>
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reference Number
            </label>
            <input
              type="text"
              name="referenceNumber"
              value={paymentFormData.referenceNumber}
              onChange={handlePaymentInputChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
              placeholder="Enter Reference Number"
            />
          </div>

          <div className="flex justify-between mt-6">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-5 rounded-lg shadow-md transition duration-150 ease-in-out"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={() => setIsModal2Open(false)}
              className="bg-gray-300 hover:bg-gray-400 text-gray-700 font-semibold py-2 px-5 rounded-lg shadow-md transition duration-150 ease-in-out"
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>
      <button
        onClick={handleDetails}
        className="bg-red-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-150 ease-in-out"
      >
        Clear Payment Details
      </button>
    </div>
  );
};

export default ProfilePayment;
